<div class="flex flex-col gap-4 h-full">
  @if(!tvQ){
    <afcu-header/>
  }
  <div [ngClass]="getBranches || resetLocation || tvQ ? 'blur-none': 'blur-3xl'" class="fixed w-full -z-20 h-full bg-[url(/images/WelcomeIllustration.png)] bg-no-repeat bg-cover"></div>
  @if (getBranches && getServices) {
    <div class="col-span-10 row-span-10 col-start-2 row-start-2 h-full">
      <afcu-loading target="start"/>
    </div>
  } @else {
    @if(resetLocation){
      <afcu-configurations class="h-full flex justify-center items-center" />
    } @else if(tvQ) {
      <div class="h-full px-6 py-8">
        <afcu-tv />
      </div>
    } @else {
      <afcu-card class="blur-none h-full md:px-20 lg:px-20 xl:px-48" [branchView]="branchView"/>
    }
    
  }
  
  @if(!tvQ){
    <afcu-footer/>
  }
</div>